<template>
    <div class="mb-5 mt-4">

        <v-expansion-panels v-model="panel">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <span v-if="panel != 0"> <strong>Trends by Age</strong> </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <ApexChart height="400" type="line" :options="chartOptions" ty :series="series">
                    </ApexChart>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

    </div>
</template>
<script>
import ApexChart from "vue-apexcharts";
export default {
    components: {
        ApexChart,
    },
    name: "Bar",

    data() {
        return {
            series: [],
            chartOptions: null,
            panel: 0

        };
    },

    created() {
        debugger
        this.getChartData();
    },

    watch: {

    },

    methods: {
        getChartData() {
            debugger
            this.$apollo
                .query({
                    query: require("@/customer/api/getAgewiseTrend.graphql"),

                })
                .then(data => {
                    debugger
                    let response = data.data.getAgewiseTrend;
                    let graphLabels = new Array();
                    let countArray = new Array();
                    response.forEach(element => {
                        countArray.push(element.count)
                        graphLabels.push(element.group)
                    });
                    debugger
                    this.series = [{
                        name: "Age Group",
                        data: countArray
                    }];

                    this.chartOptions = {
                        chart: {
                            height: 350,
                            type: 'line',
                            zoom: {
                                enabled: false
                            }
                        },
                        dataLabels: {
                            enabled: false
                        },
                        stroke: {
                            curve: 'straight'
                        },
                        title: {
                            text: 'Trends by Age',
                            align: 'left'
                        },
                        grid: {
                            row: {
                                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                opacity: 0.5
                            },
                        },
                        xaxis: {
                            categories: graphLabels,
                        }
                    }


                });
        },
    },
};
</script>
  